
export default function () {
  return {
    scope: {},
    devices: 0,
    loading: false,
  };
}
